import { LoadingService } from './../../_services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { EmailIntegrationService } from './../../_services/email-integration.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailCampaignLimitsComponent } from 'src/app/email-campaign/email-campaign-limits/email-campaign-limits.component';
import { GlobalService } from 'src/app/_services/global.service';
import { CampaignService } from 'src/app/_services/campaign.service';
declare const clevertap;
const frontendurl = environment.frontendurl
@Component({
    selector: 'app-email-integration',
    templateUrl: './email-integration.component.html',
    styleUrls: ['./email-integration.component.scss'],
    standalone: false
})
export class EmailIntegrationComponent implements OnInit {
  authurl: any;
  gmailAccountDetails: any;
  outlookAccountDetails: any;
  errorMessage: any;

  /**Tooltip message for warning */
  warningMessage: String = "";
  /**
   * Holds the integration error data passed through query params after decryption, if available and not expired
   */
  integrationErrorParamData: any = null;
  /**
   * Keeps the original encrypted state token from query params for use when calling the reactivate API
   */
  private integrationErrorEncryptedState: string | null = null;
  /**
   * Success message shown after a successful campaign reactivation
   */
  successMessage: string = '';
  /**
   * Flag to indicate if there is integration error data available from query params after decryption and validation
   */
  get isIntegrationError(): boolean {
    return this.integrationErrorParamData != null;
  }
  /**
   * Flag to indicate if the integration error data from query params is expired (older than 7 days) and has been discarded
   */
  expiredIntegration: boolean = false;

  constructor(private emailintegrationservice: EmailIntegrationService, private route : ActivatedRoute , private loader : LoadingService, private localStorageService: LocalStorageService, private ngbModal: NgbModal, private campaignService: CampaignService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if(params['e']){
        const encryptedErrorData = params['e'];
        if (encryptedErrorData) {
          try {
            const decryptedData = GlobalService.decryptData(encryptedErrorData);
            const parts = (decryptedData || '').split(':');
            const [userId, integrationId, timestamp] = parts;
            const parsedUserId = Number(userId);
            const parsedIntegrationId = Number(integrationId);
            const parsedTimestamp = new Date(Number(timestamp));
            const isValid =
              parts.length === 3 &&
              !isNaN(parsedUserId) && parsedUserId > 0 &&
              !isNaN(parsedIntegrationId) && parsedIntegrationId > 0 &&
              !isNaN(parsedTimestamp.getTime());
            if (!isValid) {
              this.integrationErrorParamData = null;
              this.integrationErrorEncryptedState = null;
            } else {
              this.integrationErrorParamData = {
                userId: parsedUserId,
                integrationId: parsedIntegrationId,
                timestamp: parsedTimestamp
              };
              // check if timestamp is within last 7 days
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
              if (this.integrationErrorParamData.timestamp < sevenDaysAgo) {
                this.integrationErrorParamData = null; // discard if older than 7 days
                this.integrationErrorEncryptedState = null;
                this.expiredIntegration = true;
                console.warn('Integration error data is older than 7 days and has been discarded.');
              } else {
                this.integrationErrorEncryptedState = encryptedErrorData;
              }
            }
          } catch {
            this.integrationErrorParamData = null;
            this.integrationErrorEncryptedState = null;
          }
        } else {
          this.integrationErrorParamData = null;
          this.integrationErrorEncryptedState = null;
        }
      }
    })
    this.fetchIntegration()
    window.addEventListener('storage', (event)=> {
      if(event.key == 'gmail_integration' || event.key == 'outlook_integration'){
        if (event.newValue == 'success') {
          // fetchIntegration is handled after the limits modal is closed
        } else {
          if(event.newValue.includes("GOOGLE_INTEGRATION")){
            this.warningMessage = "Someting went wrong"
            setTimeout(() => this.warningMessage = '', 3000);
          } else{
            this.errorMessage = event.newValue;
            setTimeout(() => this.errorMessage = '', 3000);

          }
        }
      }
      setTimeout(()=>{
        localStorage.removeItem("gmail_integration");
        localStorage.removeItem("outlook_integration");
      },2000)
    }, false);
  }

  fetchIntegration(afterFetch?: () => void){
    this.emailintegrationservice.fetchintegratedemails().subscribe((res:any)=>{
     if(res.status == 'success'){
       if(res.integratedemailsarray && res.integratedemailsarray.length){
        this.gmailAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'gmail')[0]
        this.outlookAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'outlook')[0]
       }else{
        this.gmailAccountDetails = null
        this.outlookAccountDetails = null
       }
        this.loader.stopLoading()
        if (afterFetch) afterFetch();
     }
    })
  }

  private checkAndReactivateIntegration(): void {
    if (!this.integrationErrorParamData || !this.integrationErrorEncryptedState) return;
    const matchesGmail = this.gmailAccountDetails?.useremailintegrationid == this.integrationErrorParamData.integrationId;
    const matchesOutlook = this.outlookAccountDetails?.useremailintegrationid == this.integrationErrorParamData.integrationId;
    if (matchesGmail || matchesOutlook) {
      const encryptedState = this.integrationErrorEncryptedState;
      this.integrationErrorParamData = null;
      this.integrationErrorEncryptedState = null;
      this.campaignService.reactivateIntegrationErroredCampaigns(encryptedState).subscribe((res: any) => {
        if (res && res.status === 'success') {
          this.successMessage = res.message || 'Campaigns reactivated successfully.';
          setTimeout(() => this.successMessage = '', 5000);
        } else {
          this.errorMessage = (res && res.message) || 'Failed to reactivate campaigns. Please try again.';
          setTimeout(() => this.errorMessage = '', 5000);
        }
      });
    }
  }

  connectoGmail(){
    let data ={
      "redirectionurl": `${frontendurl}/email_redirection?integrate=gmail`
    }
    this.emailintegrationservice.gmailintegrationurl(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.authurl = res.url
        var winObj = window.open(this.authurl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        var loop = setInterval(() => {
          if(winObj.closed) {
            clearInterval(loop);
            this.showLimitsAcknowledgeModal(() => this.checkAndReactivateIntegration());
            if(!localStorage.getItem('gmail_integration_completed')){
                /**
           * integration of emaail connection
           */
                 const emailIntegrationParams = {
                  "User ID": this.localStorageService.getItem('userdata').userid,
                  "Email Connected": "Yes",
                  "Source": "Settings",
                  "Platform": "Gmail"
                }
                clevertap.event.push('Email connected', emailIntegrationParams);
            //  clevertap.event.push('IntegrationAttempt_Gmail');
            }
          }
      }, 1000);

      }else{

        this.errorMessage = res.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  connectoOutlook(){
    let data ={
      "redirectionurl": `${frontendurl}/email_redirection`
    }
    this.emailintegrationservice.outlookintegrationurl(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.authurl = res.url
        var winObj = window.open(this.authurl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        var loop = setInterval(() => {
          if(winObj.closed) {
            clearInterval(loop);
            this.showLimitsAcknowledgeModal(() => this.checkAndReactivateIntegration());
            if(!localStorage.getItem('outlook_integration_completed')){
          /**
           * integration of emaail connection
           */
                 const emailIntegrationParams = {
                  "User ID": this.localStorageService.getItem('userdata').userid,
                  "Email Connected": "Yes",
                  "Source": "Settings",
                  "Platform": "Outlook"
                }
                clevertap.event.push('Email connected', emailIntegrationParams);
           //   clevertap.event.push('IntegrationAttempt_Outlook');
            }
          }
      }, 1000);
      }else{

        this.errorMessage = res.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  disconnectEmailIntegration(type){
    let data ={
      emailid : type? this.outlookAccountDetails.emailid : this.gmailAccountDetails.emailid,
      integrationplatform : type ? 'outlook' : 'gmail'
    }

    this.emailintegrationservice.disconnectemail(data).subscribe((res:any)=>{
      data.integrationplatform == 'outlook' ? localStorage.removeItem('outlook_integration_completed') : localStorage.removeItem('gmail_integration_completed')
      this.fetchIntegration()
    })
  }

  private showLimitsAcknowledgeModal(afterFetch?: () => void): void {
    const ref = this.ngbModal.open(EmailCampaignLimitsComponent, { backdrop: 'static', centered: true, size: 'lg' });
    ref.componentInstance.mode = 'acknowledge';
    ref.result.then(
      () => this.fetchIntegration(afterFetch),
      () => this.fetchIntegration(afterFetch)
    );
  }

}
